import store from '@/store';
import axios from 'axios';
import { BaseV1ApiService } from '@/services/backend/baseV1';

export class Fl44UnknownVolumeContracts extends BaseV1ApiService {
    constructor() {
        super('purchases/fl44_unknown_volume');
    }

    async store(id, attachment) {
        try {
            await axios.post(this.getUrl(`${id}/contracts`), {
                contract_attachment: { ...attachment }
            });
            await store.dispatch('showSuccessToast', 'Контракт успешно отправлен');
            return true;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async getXml(id, contractId, payload = null) {
        try {
            const response = await axios.post(this.getUrl(`${id}/contracts/${contractId}/xml`), payload);
            return response.data;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async storeSigned(id, contractId, path, payload) {
        try {
            await axios.put(this.getUrl(`${id}/contracts/${contractId}/${path}/store_signed`), {
                ...payload
            });
            await store.dispatch('showSuccessToast', 'Контракт успешно подписан');
            return true;
        } catch (err) {
            this.handleErrors(err);
            return false;
        }
    }

    async storeSignedDisagreement(id, contractId, path, payload, disagreementId = null) {
        try {
            await axios.post(this.getUrl(`${id}/contracts/${contractId}/${path}/${disagreementId ? disagreementId : 'disagreement'}`), {
                ...payload
            });
            await store.dispatch('showSuccessToast', 'Действие выполнено успешно');
            return true;
        } catch (err) {
            this.handleErrors(err);
            return false;
        }
    }

    async updateContractLimits(id, contractId, payload) {
        try {
            await axios.post(this.getUrl(`${id}/contracts/${contractId}/update_limits`), payload);
            await store.dispatch('showSuccessToast', 'Лимиты обновлены');
            return true;
        } catch (err) {
            this.handleErrors(err);
            return false;
        }
    }
}
